import { z } from 'zod';

/** Profile exports (BB-50): need `data.export`; personal columns also `pii.view`. */
export const EXPORT_TTL_HOURS = 4;
export const CreateExportBody = z.strictObject({ columns: z.array(z.string().min(1).max(300)).min(1).max(100) });
export type CreateExportBody = z.infer<typeof CreateExportBody>;

export interface ExportColumnOption {
  id: string;
  label: string;
  pii: boolean;
  /** The reader may export it (personal columns need `pii.view`). */
  allowed: boolean;
}

export interface ExportView {
  id: string;
  kind: 'segment' | 'global_control';
  status: 'queued' | 'running' | 'completed' | 'failed' | 'expired';
  segmentId: string | null;
  segmentName: string | null;
  columns: string[];
  /** Personal columns asked for without `pii.view`: left out of the file. */
  droppedColumns: string[];
  rowCount: number | null;
  error: string | null;
  createdAt: string;
  completedAt: string | null;
  expiresAt: string | null;
  /** Relative API path while the file can be downloaded. */
  downloadPath: string | null;
}
